export const issueTableColumnClass = {
  issueKey: 'pf-m-width-15 wrap-column ',
  bugUrl: 'pf-m-width-20 ',
  cveUrl: 'pf-m-width-15 ',
  components: 'pf-m-width-15 ',
  summary: 'pf-m-width-20 pf-m-width-15-on-xl ',
  uploadDate: 'pf-m-width-15 pf-m-width-10-on-xl ',
  status: 'pf-m-hidden pf-m-visible-on-xl pf-m-width-15 ',
  kebab: 'pf-v6-c-table__action',
};

export const cveTableColumnClass = {
  issueKey: 'pf-m-width-15 wrap-column ',
  component: 'pf-m-width-30 ',
  packages: 'pf-m-width-40',
  kebab: 'pf-v6-c-table__action',
};
